module.exports = __webpack_public_path__ + "static/media/dealers.3b639c04.svg";